import { render, staticRenderFns } from "./TreatmentAdviceStatus.vue?vue&type=template&id=b510582e&scoped=true&"
import script from "./TreatmentAdviceStatus.vue?vue&type=script&lang=js&"
export * from "./TreatmentAdviceStatus.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentAdviceStatus.vue?vue&type=style&index=0&id=b510582e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b510582e",
  null
  
)

export default component.exports